module.exports = __webpack_public_path__ + "img/about-1.e348b21f.png";